import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import { useAnnonces } from "../context/AnnoncesContext";
import { useMessages } from "../context/MessagesContext";
import MessagesBadge from "./MessagesBadge";
import DarkModeToggle from "./DarkModeToggle";
import NotificationsBell from "./NotificationsBell";

function Navbar() {
  const [searchTerm, setSearchTerm] = useState("");
  const [showResults, setShowResults] = useState(false);
  const [showUserMenu, setShowUserMenu] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);
  const { user, logout } = useAuth();
  const { annonces } = useAnnonces();
  const { unread } = useMessages();
  const navigate = useNavigate();
const unreadCount = user ? unread : 0;

  const filteredProducts = annonces.filter(item =>
    item.nom.toLowerCase().includes(searchTerm.toLowerCase()) ||
    item.description.toLowerCase().includes(searchTerm.toLowerCase())
  );

  const handleLogout = () => {
    logout();
    setShowUserMenu(false);
    setMenuOpen(false);
    navigate("/");
  };

  const getRoleLabel = (role) => {
    if (role === "admin") return "Administrateur";
    if (role === "exposant") return "Exposant";
    return "Acheteur";
  };

  const getRoleColor = (role) => {
    if (role === "admin") return "#dc2626";
    if (role === "exposant") return "#0d9488";
    return "#6366f1";
  };

  return (
    <nav style={{
      backgroundColor: "white",
      borderBottom: "1px solid #e5e7eb",
      padding: "15px 50px",
      position: "sticky",
      top: 0,
      zIndex: 100
    }}>
      <div style={{
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        maxWidth: "1400px",
        margin: "0 auto"
      }}>

        {/* ── Logo ── */}
        <Link to="/" style={{ textDecoration: "none", display: "flex", alignItems: "center", gap: "10px" }}>
          <span style={{ fontSize: "22px", fontWeight: "700", color: "#1f2937" }}>
            Marina<span style={{ color: "#0d9488" }}>DZ</span>
          </span>
        </Link>

        {/* ── Navigation desktop ── */}
        <div className="navbar-desktop-links" style={{ display: "flex", alignItems: "center", gap: "35px" }}>
          <Link to="/" style={{ textDecoration: "none", color: "#374151", fontSize: "15px", fontWeight: "500" }}>Accueil</Link>
          <Link to="/catalogue" style={{ textDecoration: "none", color: "#374151", fontSize: "15px", fontWeight: "500" }}>Catalogue</Link>
          <Link to="/rfq" style={{ textDecoration: "none", color: "#374151", fontSize: "15px", fontWeight: "500" }}>RFQ</Link>
          <Link to="/abonnement" style={{ textDecoration: "none", backgroundColor: "#0d9488", color: "white", padding: "7px 14px", borderRadius: "8px", fontSize: "13px", fontWeight: "700" }}>Abonnements</Link>
        </div>

        {/* ── Search desktop ── */}
        <div className="navbar-search" style={{ position: "relative", flex: 1, maxWidth: "350px", margin: "0 40px" }}>
          <div style={{ display: "flex", alignItems: "center", backgroundColor: "#f9fafb", border: "1px solid #e5e7eb", borderRadius: "8px", overflow: "hidden" }}>
            <span style={{ padding: "0 12px", color: "#9ca3af" }}>
              <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                <circle cx="11" cy="11" r="8"/><line x1="21" y1="21" x2="16.65" y2="16.65"/>
              </svg>
            </span>
            <input
              type="text"
              placeholder="Rechercher..."
              value={searchTerm}
              onChange={(e) => { setSearchTerm(e.target.value); setShowResults(e.target.value.length > 0); }}
              onFocus={() => searchTerm.length > 0 && setShowResults(true)}
              onBlur={() => setTimeout(() => setShowResults(false), 200)}
              style={{ flex: 1, padding: "12px 15px 12px 0", border: "none", outline: "none", fontSize: "14px", backgroundColor: "transparent" }}
            />
          </div>
          {showResults && searchTerm && (
            <div style={{ position: "absolute", top: "100%", left: 0, right: 0, backgroundColor: "white", boxShadow: "0 4px 20px rgba(0,0,0,0.15)", borderRadius: "8px", marginTop: "5px", maxHeight: "300px", overflowY: "auto", zIndex: 1000 }}>
              {filteredProducts.length > 0 ? filteredProducts.map((item) => (
                <Link key={item.id} to={`/annonce/${item.id}`} style={{ display: "flex", alignItems: "center", padding: "12px 15px", textDecoration: "none", color: "#1f2937", borderBottom: "1px solid #f3f4f6" }}>
                  <img src={item.image || "/placeholder.svg"} alt={item.nom} style={{ width: "45px", height: "45px", objectFit: "cover", borderRadius: "6px", marginRight: "12px" }} />
                  <div>
                    <div style={{ fontWeight: "600", fontSize: "14px" }}>{item.nom}</div>
                    <div style={{ fontSize: "13px", color: "#0d9488" }}>{item.prix}</div>
                  </div>
                </Link>
              )) : (
                <div style={{ padding: "20px", color: "#6b7280", textAlign: "center" }}>Aucun résultat pour "{searchTerm}"</div>
              )}
            </div>
          )}
        </div>

        {/* ── Actions droite desktop ── */}
        <div className="navbar-right-actions" style={{ display: "flex", alignItems: "center", gap: "20px" }}>
          {user ? (
            <>
              <DarkModeToggle />
              <NotificationsBell />
              <MessagesBadge />
              <div style={{ position: "relative" }}>
                <button
                  onClick={() => setShowUserMenu(!showUserMenu)}
                  style={{ display: "flex", alignItems: "center", gap: "10px", backgroundColor: "white", border: "1px solid #e5e7eb", borderRadius: "8px", padding: "8px 14px", cursor: "pointer" }}
                >
                  <div style={{ width: "32px", height: "32px", borderRadius: "50%", backgroundColor: getRoleColor(user.role), display: "flex", alignItems: "center", justifyContent: "center", color: "white", fontSize: "14px", fontWeight: "700" }}>
                    {user.prenom?.[0]}{user.nom?.[0]}
                  </div>
                  <div style={{ textAlign: "left" }}>
                    <div style={{ fontSize: "13px", fontWeight: "600", color: "#1f2937" }}>{user.prenom} {user.nom}</div>
                    <div style={{ fontSize: "11px", color: getRoleColor(user.role), fontWeight: "600" }}>
                      {getRoleLabel(user.role)}
                      {user.plan && user.plan !== "free" && user.plan !== "gratuit" && (
                        <span style={{ marginLeft: 5, backgroundColor: user.plan === "enterprise" ? "#7c3aed" : "#0d9488", color: "white", padding: "1px 6px", borderRadius: 8, fontSize: 9, fontWeight: 800 }}>
                          {user.plan === "enterprise" ? "Enterprise" : "Business"}
                        </span>
                      )}
                    </div>
                  </div>
                  <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="#9ca3af" strokeWidth="2"><path d="M6 9l6 6 6-6"/></svg>
                </button>

                {showUserMenu && (
                  <div style={{ position: "absolute", top: "100%", right: 0, marginTop: "8px", backgroundColor: "white", border: "1px solid #e5e7eb", borderRadius: "12px", boxShadow: "0 8px 30px rgba(0,0,0,0.15)", zIndex: 1000, minWidth: "220px", overflow: "hidden" }}>
                    <div style={{ padding: "15px", borderBottom: "1px solid #f3f4f6", backgroundColor: "#f9fafb" }}>
                      <div style={{ fontSize: "14px", fontWeight: "600", color: "#1f2937" }}>{user.prenom} {user.nom}</div>
                      <div style={{ fontSize: "12px", color: "#6b7280" }}>{user.email}</div>
                      <span style={{ display: "inline-block", marginTop: "6px", backgroundColor: getRoleColor(user.role) + "20", color: getRoleColor(user.role), padding: "2px 10px", borderRadius: "20px", fontSize: "11px", fontWeight: "700" }}>
                        {getRoleLabel(user.role)}
                      </span>
                    </div>
                    {user.role === "admin" && (
                      <Link to="/admin" onClick={() => setShowUserMenu(false)} style={{ display: "flex", alignItems: "center", gap: "10px", padding: "12px 15px", textDecoration: "none", color: "#dc2626", fontSize: "14px", fontWeight: "600", borderBottom: "1px solid #f3f4f6" }}>
                        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><rect x="3" y="3" width="7" height="7"/><rect x="14" y="3" width="7" height="7"/><rect x="14" y="14" width="7" height="7"/><rect x="3" y="14" width="7" height="7"/></svg>
                        Dashboard Admin
                      </Link>
                    )}
                    <Link to="/mon-espace" onClick={() => setShowUserMenu(false)} style={{ display: "flex", alignItems: "center", gap: "10px", padding: "12px 15px", textDecoration: "none", color: "#374151", fontSize: "14px" }}>
                      <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M20 21v-2a4 4 0 00-4-4H8a4 4 0 00-4 4v2"/><circle cx="12" cy="7" r="4"/></svg>
                      Mon espace
                    </Link>
                    <Link to="/abonnement" onClick={() => setShowUserMenu(false)} style={{ display: "flex", alignItems: "center", gap: "10px", padding: "12px 15px", textDecoration: "none", color: "#0d9488", fontSize: "14px", fontWeight: "600" }}>
                      <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M9 12l2 2 4-4M7.835 4.697a3.42 3.42 0 001.946-.806 3.42 3.42 0 014.438 0 3.42 3.42 0 001.946.806 3.42 3.42 0 013.138 3.138 3.42 3.42 0 00.806 1.946 3.42 3.42 0 010 4.438 3.42 3.42 0 00-.806 1.946 3.42 3.42 0 01-3.138 3.138 3.42 3.42 0 00-1.946.806 3.42 3.42 0 01-4.438 0 3.42 3.42 0 00-1.946-.806 3.42 3.42 0 01-3.138-3.138 3.42 3.42 0 00-.806-1.946 3.42 3.42 0 010-4.438 3.42 3.42 0 00.806-1.946 3.42 3.42 0 013.138-3.138z"/></svg>
                      Mon abonnement
                    </Link>
                    {user.role === "acheteur" && (
                      <Link to="/devenir-exposant" onClick={() => setShowUserMenu(false)} style={{ display: "flex", alignItems: "center", gap: "10px", padding: "12px 15px", textDecoration: "none", color: "#0d9488", fontSize: "14px", fontWeight: "600", borderTop: "1px solid #f3f4f6" }}>
                        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z"/></svg>
                        Devenir Exposant
                      </Link>
                    )}
                    {user.role === "exposant" && (
                      <Link to="/mes-annonces" onClick={() => setShowUserMenu(false)} style={{ display: "flex", alignItems: "center", gap: "10px", padding: "12px 15px", textDecoration: "none", color: "#374151", fontSize: "14px" }}>
                        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M14 2H6a2 2 0 00-2 2v16a2 2 0 002 2h12a2 2 0 002-2V8z"/><polyline points="14 2 14 8 20 8"/></svg>
                        Mes annonces
                      </Link>
                    )}
                    <button onClick={handleLogout} style={{ width: "100%", display: "flex", alignItems: "center", gap: "10px", padding: "12px 15px", border: "none", backgroundColor: "transparent", color: "#dc2626", fontSize: "14px", cursor: "pointer", borderTop: "1px solid #f3f4f6", textAlign: "left" }}>
                      <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M9 21H5a2 2 0 01-2-2V5a2 2 0 012-2h4"/><polyline points="16 17 21 12 16 7"/><line x1="21" y1="12" x2="9" y2="12"/></svg>
                      Se déconnecter
                    </button>
                  </div>
                )}
              </div>
            </>
          ) : (
            <>
              <Link to="/connexion" style={{ textDecoration: "none", color: "#374151", fontSize: "15px", fontWeight: "500" }}>Connexion</Link>
              <Link to="/inscription" style={{ textDecoration: "none", backgroundColor: "#0d9488", color: "white", padding: "10px 20px", borderRadius: "8px", fontSize: "14px", fontWeight: "600" }}>S'inscrire</Link>
              <DarkModeToggle />
            </>
          )}
        </div>

        {/* ── Hamburger mobile ── */}
        <button className="navbar-hamburger" onClick={() => setMenuOpen(!menuOpen)} aria-label="Menu">
          {menuOpen ? (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="#1f2937" strokeWidth="2">
              <line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/>
            </svg>
          ) : (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="#1f2937" strokeWidth="2">
              <line x1="3" y1="6" x2="21" y2="6"/><line x1="3" y1="12" x2="21" y2="12"/><line x1="3" y1="18" x2="21" y2="18"/>
            </svg>
          )}
        </button>
      </div>

      {/* ══════════════════════════════════════
          MENU MOBILE
      ══════════════════════════════════════ */}
      {menuOpen && (
        <div className="navbar-mobile-menu">

          {/* Recherche mobile */}
          <div style={{ display: "flex", alignItems: "center", backgroundColor: "#f9fafb", border: "1px solid #e5e7eb", borderRadius: "8px", marginBottom: "4px", overflow: "hidden" }}>
            <span style={{ padding: "0 12px", color: "#9ca3af" }}>
              <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                <circle cx="11" cy="11" r="8"/><line x1="21" y1="21" x2="16.65" y2="16.65"/>
              </svg>
            </span>
            <input
              type="text"
              placeholder="Rechercher..."
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
              style={{ flex: 1, padding: "12px 8px", border: "none", outline: "none", fontSize: "14px", backgroundColor: "transparent" }}
            />
          </div>

          {/* Liens navigation */}
          <Link to="/" onClick={() => setMenuOpen(false)}>Accueil</Link>
          <Link to="/catalogue" onClick={() => setMenuOpen(false)}>Catalogue</Link>
          <Link to="/exposants" onClick={() => setMenuOpen(false)}>Exposants</Link>
          <Link to="/rfq" onClick={() => setMenuOpen(false)}>RFQ</Link>
          <Link to="/abonnement" onClick={() => setMenuOpen(false)} style={{ color: "#0d9488", fontWeight: "700" }}>Abonnements</Link>
          <Link to="/a-propos" onClick={() => setMenuOpen(false)}>À propos</Link>
          <Link to="/contact" onClick={() => setMenuOpen(false)}>Contact</Link>

          {user ? (
            <>
              {/* ── Bloc utilisateur + icône messagerie côte à côte ── */}
              <div style={{
                padding: "12px 0",
                borderBottom: "1px solid #e5e7eb",
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
                gap: "12px"
              }}>
                {/* Infos utilisateur */}
                <div>
                  <div style={{ fontSize: "14px", fontWeight: "700", color: "#1f2937" }}>
                    {user.prenom} {user.nom}
                  </div>
                  <div style={{ fontSize: "12px", color: getRoleColor(user.role), fontWeight: "600" }}>
                    {getRoleLabel(user.role)}
                  </div>
                </div>

                {/* Icône messagerie avec badge rouge */}
                <Link
                  to="/messages"
                  onClick={() => setMenuOpen(false)}
                  style={{
                    position: "relative",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    width: "42px",
                    height: "42px",
                    borderRadius: "10px",
                    backgroundColor: unread > 0 ? "#f0fdfa" : "white",
                    border: `1px solid ${unread > 0 ? "#0d9488" : "#e5e7eb"}`,
                    textDecoration: "none",
                    flexShrink: 0
                  }}
                  title="Messagerie"
                >
                  <svg
                    width="20" height="20" viewBox="0 0 24 24"
                    fill="none" stroke={unreadCount > 0 ? "#0d9488" : "#374151"} strokeWidth="2"
                  >
                    <path d="M21 15a2 2 0 01-2 2H7l-4 4V5a2 2 0 012-2h14a2 2 0 012 2z"/>
                  </svg>
                  {unread > 0 && (
                    <span style={{
                      position: "absolute",
                      top: "-6px",
                      right: "-6px",
                      backgroundColor: "#dc2626",
                      color: "white",
                      borderRadius: "50%",
                      width: "18px",
                      height: "18px",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      fontSize: "10px",
                      fontWeight: "700",
                      border: "2px solid white"
                    }}>
                      {unreadCount > 9 ? "9+" : unreadCount}
                    </span>
                  )}
                </Link>
              </div>

              {user.role === "admin" && (
                <Link to="/admin" onClick={() => setMenuOpen(false)} style={{ color: "#dc2626", fontWeight: "600" }}>
                  🛠️ Dashboard Admin
                </Link>
              )}
              <Link to="/mon-espace" onClick={() => setMenuOpen(false)}>Mon espace</Link>
              {user.role === "exposant" && (
                <Link to="/mes-annonces" onClick={() => setMenuOpen(false)}>📄 Mes annonces</Link>
              )}
              {user.role === "acheteur" && (
                <Link to="/devenir-exposant" onClick={() => setMenuOpen(false)} style={{ color: "#0d9488", fontWeight: "600" }}>
                  Devenir Exposant
                </Link>
              )}
              <button onClick={handleLogout} style={{ color: "#dc2626", fontWeight: "600" }}>
                Se déconnecter
              </button>
            </>
          ) : (
            <>
              <Link to="/connexion" onClick={() => setMenuOpen(false)}>🔐 Connexion</Link>
              <Link
                to="/inscription"
                onClick={() => setMenuOpen(false)}
                style={{ backgroundColor: "#0d9488", color: "white", padding: "12px 16px", borderRadius: "8px", textAlign: "center", fontWeight: "600", marginTop: "4px", display: "block", textDecoration: "none" }}
              >
                S'inscrire
              </Link>
            </>
          )}
        </div>
      )}
    </nav>
  );
}

export default Navbar;